'use strict';
//copied from server Errors.java
export var Errors;
(function (Errors) {
    Errors[Errors["UNKNOWN"] = -1] = "UNKNOWN";
    Errors[Errors["GENERAL"] = -10] = "GENERAL";
    Errors[Errors["NO_PERMISSION"] = -50001] = "NO_PERMISSION";
    Errors[Errors["RUNTIME"] = -50002] = "RUNTIME";
    Errors[Errors["VALIDATION"] = -50004] = "VALIDATION";
    Errors[Errors["USER_SESSION_NOT_FOUND"] = -50005] = "USER_SESSION_NOT_FOUND";
    Errors[Errors["NOT_FOUND"] = -50006] = "NOT_FOUND";
    Errors[Errors["USER_PERMISSION_NOT_FOUND"] = -50008] = "USER_PERMISSION_NOT_FOUND";
    // general errors
    Errors[Errors["NOTE_NOT_FOUND"] = -51001] = "NOTE_NOT_FOUND";
    Errors[Errors["FOLLOWER_NOT_FOUND"] = -51005] = "FOLLOWER_NOT_FOUND";
    Errors[Errors["DUPLICATE_FOLLOWER_ERROR"] = -51012] = "DUPLICATE_FOLLOWER_ERROR";
    Errors[Errors["NOTIFICATION_SENDER_ERROR"] = -51010] = "NOTIFICATION_SENDER_ERROR";
    Errors[Errors["SAVED_REPLY_NOT_FOUND"] = -51029] = "SAVED_REPLY_NOT_FOUND";
    // users errors
    Errors[Errors["USER_NOT_FOUND"] = -52001] = "USER_NOT_FOUND";
    Errors[Errors["USER_BAN_NOT_FOUND"] = -52002] = "USER_BAN_NOT_FOUND";
    Errors[Errors["AUTH_USER_ERROR"] = -52003] = "AUTH_USER_ERROR";
    Errors[Errors["CONFLICTING_USER_ERROR"] = -52004] = "CONFLICTING_USER_ERROR";
    Errors[Errors["DUPLICATE_USER_BAN_ERROR"] = -52005] = "DUPLICATE_USER_BAN_ERROR";
    // file upload
    Errors[Errors["FILE_UPLOAD"] = -54001] = "FILE_UPLOAD";
    // tenants
    Errors[Errors["TENANT_NOT_FOUND"] = -57001] = "TENANT_NOT_FOUND";
    Errors[Errors["TENANT_UPDATE_ERROR"] = -57002] = "TENANT_UPDATE_ERROR";
    Errors[Errors["LANGUAGE_NOT_SUPPORTED_ERROR"] = -57003] = "LANGUAGE_NOT_SUPPORTED_ERROR";
    Errors[Errors["URL_MAPPING_NOT_FOUND"] = -57004] = "URL_MAPPING_NOT_FOUND";
    // multilingual
    Errors[Errors["MULTILINGUAL_ITEM_NOT_FOUND"] = -58001] = "MULTILINGUAL_ITEM_NOT_FOUND";
    // permalink
    Errors[Errors["PERMALINK_NOT_FOUND"] = -59001] = "PERMALINK_NOT_FOUND";
    Errors[Errors["ITEM_PERMALINKS_NOT_FOUND"] = -59002] = "ITEM_PERMALINKS_NOT_FOUND";
    Errors[Errors["PERMALINK_NOT_EXACT_MATCH"] = -59003] = "PERMALINK_NOT_EXACT_MATCH";
    // categories errors
    Errors[Errors["CATEGORY_NOT_FOUND"] = -60001] = "CATEGORY_NOT_FOUND";
    Errors[Errors["CATEGORY_CANNOT_DELETE_NODE_WITH_CHILDREN_ERROR"] = -60002] = "CATEGORY_CANNOT_DELETE_NODE_WITH_CHILDREN_ERROR";
    // mailbox
    Errors[Errors["EMAIL_ITEM_PUBLISH_ERROR"] = -61001] = "EMAIL_ITEM_PUBLISH_ERROR";
    Errors[Errors["MONITORED_EMAIL_NOT_FOUND"] = -61002] = "MONITORED_EMAIL_NOT_FOUND";
    Errors[Errors["EMAIL_MONITOR_ERROR"] = -61003] = "EMAIL_MONITOR_ERROR";
    Errors[Errors["MAILBOX_CONFIGURATION_ERROR"] = -61004] = "MAILBOX_CONFIGURATION_ERROR";
    Errors[Errors["NEW_MAILBOX_FOLDER_NOT_EMPTY_ERROR"] = -61005] = "NEW_MAILBOX_FOLDER_NOT_EMPTY_ERROR";
    // auth
    Errors[Errors["AUTH_USER_NOT_FOUND"] = -63001] = "AUTH_USER_NOT_FOUND";
    Errors[Errors["USER_AUTHORIZATION_NOT_FOUND"] = -63002] = "USER_AUTHORIZATION_NOT_FOUND";
    // settings
    Errors[Errors["SETTING_NOT_FOUND"] = -65001] = "SETTING_NOT_FOUND";
    Errors[Errors["SYSTEM_SETTING_PARSE_ERROR"] = -65002] = "SYSTEM_SETTING_PARSE_ERROR";
    // knowledgebase
    Errors[Errors["KB_ITEM_NOT_FOUND"] = -66001] = "KB_ITEM_NOT_FOUND";
    Errors[Errors["KB_ITEM_NOT_FOUND_IN_LANGS"] = -66002] = "KB_ITEM_NOT_FOUND_IN_LANGS";
    // version
    Errors[Errors["VERSION_NOT_FOUND"] = -67001] = "VERSION_NOT_FOUND";
    // new core
    Errors[Errors["UGC_ITEM_NOT_FOUND"] = -68001] = "UGC_ITEM_NOT_FOUND";
    Errors[Errors["TICKET_NOT_FOUND"] = -68002] = "TICKET_NOT_FOUND";
    // History
    Errors[Errors["HISTORY_RECORD_NOT_FOUND"] = -69001] = "HISTORY_RECORD_NOT_FOUND";
    Errors[Errors["PRESENCE_INFO_NOT_FOUND"] = -70001] = "PRESENCE_INFO_NOT_FOUND";
    Errors[Errors["ITEM_RELATION_NOT_FOUND"] = -71001] = "ITEM_RELATION_NOT_FOUND";
    // Notifications
    Errors[Errors["NOTIFICATION_TEMPLATE_NOT_FOUND"] = -80001] = "NOTIFICATION_TEMPLATE_NOT_FOUND";
    Errors[Errors["NOTIFICATION_RENDER_ERROR"] = -80002] = "NOTIFICATION_RENDER_ERROR";
    // Labels
    Errors[Errors["LABEL_NOT_FOUND"] = -90001] = "LABEL_NOT_FOUND";
    Errors[Errors["DUPLICATE_LABEL_ERROR"] = -90002] = "DUPLICATE_LABEL_ERROR";
    // api
    Errors[Errors["API_KEY_NOT_FOUND"] = -100001] = "API_KEY_NOT_FOUND";
    Errors[Errors["API_REQUEST_AUTHENTICATION_ERROR"] = -100002] = "API_REQUEST_AUTHENTICATION_ERROR";
    Errors[Errors["PHONE_API_EXCEPTION"] = -110001] = "PHONE_API_EXCEPTION";
    Errors[Errors["SCHEDULED_CALL_EXISTS_EXCEPTION"] = -110002] = "SCHEDULED_CALL_EXISTS_EXCEPTION";
    // widget
    Errors[Errors["WIDGET_NOT_FOUND"] = -120001] = "WIDGET_NOT_FOUND";
    // content
    Errors[Errors["ARTICLE_CONTENT_UNSUPPORTED"] = -140001] = "ARTICLE_CONTENT_UNSUPPORTED";
})(Errors || (Errors = {}));
//# sourceMappingURL=errors.enum.js.map